import { Pipe, PipeTransform } from '@angular/core';

export interface HighlightSegment {
	text: string;
	match: boolean;
}

// Splits text into matched / unmatched segments so the template can wrap matches in <mark>
// without binding API values through innerHTML. `term` must already be lower-cased.
@Pipe({ name: 'highlightSegments' })
export class HighlightSegmentsPipe implements PipeTransform {
	transform(text: string | null | undefined, term: string): HighlightSegment[] {
		const value = text ?? '';
		if (!term) {
			return [{ text: value, match: false }];
		}
		const lower = value.toLowerCase();
		const segments: HighlightSegment[] = [];
		let start = 0;
		let index = lower.indexOf(term);
		while (index !== -1) {
			if (index > start) {
				segments.push({ text: value.substring(start, index), match: false });
			}
			segments.push({
				text: value.substring(index, index + term.length),
				match: true,
			});
			start = index + term.length;
			index = lower.indexOf(term, start);
		}
		if (start < value.length) {
			segments.push({ text: value.substring(start), match: false });
		}
		return segments;
	}
}
